import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  WEB_CLOCK_JWT_REFRESH_RESULT_EVENT,
  hasJwtRefreshBridge,
  requestJwtRefresh,
} from '../utils/webClockJwtRefreshBridge';

export function useJwtRefresh() {
  const canRefresh = useMemo(() => hasJwtRefreshBridge(), []);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const hasRequestedRef = useRef(false);

  useEffect(() => {
    const handleRefreshResult = (event) => {
      if (event.detail?.status !== 'failed') {
        return;
      }
      hasRequestedRef.current = false;
      setIsRefreshing(false);
    };

    window.addEventListener(
      WEB_CLOCK_JWT_REFRESH_RESULT_EVENT,
      handleRefreshResult
    );
    return () => {
      window.removeEventListener(
        WEB_CLOCK_JWT_REFRESH_RESULT_EVENT,
        handleRefreshResult
      );
    };
  }, []);

  const handleRefresh = useCallback(() => {
    if (hasRequestedRef.current) {
      return;
    }
    hasRequestedRef.current = true;
    setIsRefreshing(true);
    requestJwtRefresh();
  }, []);

  return { canRefresh, isRefreshing, handleRefresh };
}
